import common from "./en.json";
import { enTranslations as login } from "../../pages/LocalLogin/translations";
import { enTranslations as paymentMethods } from "../../pages/PaymentMethods/translations";
import { enTranslations as dashboard } from "../../pages/Dashboard/translations";
import { enTranslations as invoices } from "../../pages/Invoices/translations";
import { enTranslations as payInvoices } from "../../pages/PayInvoices/translations";
import { enTranslations as invoice } from "../../pages/Invoice/translations";
import { enTranslations as securityDeposit } from "../../pages/SecurityDeposit/translations";

export default {
  common,
  login,
  dashboard,
  paymentMethods,
  invoices,
  payInvoices,
  invoice,
  securityDeposit,
};
